import {AccountSettingsPanel} from '../account-settings-panel';
import {Button} from '@common/ui/buttons/button';
import {DialogTrigger} from '@common/ui/overlays/dialog/dialog-trigger';
import {ConfirmationDialog} from '@common/ui/overlays/dialog/confirmation-dialog';
import {useDeleteAccount} from './delete-account';
import {Trans} from '@common/i18n/trans';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';

export function DangerZonePanel() {
  const deleteAccount = useDeleteAccount();

  return (
    <AccountSettingsPanel
      id={AccountSettingsId.DeleteAccount}
      title={<Trans message="Аюултай бүс" />}
    >
      <DialogTrigger
        type="modal"
        onClose={isConfirmed => {
          if (isConfirmed) {
            deleteAccount.mutate();
          }
        }}
      >
        <Button variant="flat" color="danger">
          <Trans message="Бүртгэл устгах" />
        </Button>
        <ConfirmationDialog
          isDanger
          title={<Trans message="Бүртгэл устгах уу?" />}
          body={
            <Trans message="Та устгах товч дарсанаар таны бүртгэл дахин сэргээгдэхгүйгээр устах ба таны вебсайтууд ч сэргээх боломжгүй болно." />
          }
          confirm={<Trans message="Устгах" />}
        />
      </DialogTrigger>
    </AccountSettingsPanel>
  );
}
